<template>
    <div class="tinymce-editor">
        <Editor
                :id="tinymceId"
                :init="init"
                :disabled="disabled"
                v-model="myValue"
                @onClick="onClick"
        ></Editor>
    </div>
</template>

<script>
    import ajax from "axios"
    import tinymce from 'tinymce/tinymce' //tinymce默认hidden，不引入不显示
    import Editor from '@tinymce/tinymce-vue'//编辑器引入
    import 'tinymce/themes/silver/theme'//编辑器主题
    import 'tinymce/icons/default'  //引入编辑器图标icon，不引入则不显示对应图标
    // 引入编辑器插件（基本免费插件都在这儿了）
    //import 'tinymce/plugins/advlist'  //高级列表
    //import 'tinymce/plugins/anchor'  //锚点
    import 'tinymce/plugins/autolink'  //自动链接
    import 'tinymce/plugins/autoresize'  //编辑器高度自适应,注：plugins里引入此插件时，Init里设置的height将失效
    //import 'tinymce/plugins/autosave'  //自动存稿
    import 'tinymce/plugins/charmap'  //特殊字符
    import 'tinymce/plugins/code'  //编辑源码
    //import 'tinymce/plugins/codesample'  //代码示例
    import 'tinymce/plugins/directionality'  //文字方向
    import 'tinymce/plugins/fullpage'  //文档属性
    import 'tinymce/plugins/fullscreen'  //全屏
    //import 'tinymce/plugins/help'  //帮助
    import 'tinymce/plugins/hr'  //水平分割线
    import 'tinymce/plugins/image'  //插入编辑图片
    //import 'tinymce/plugins/importcss'  //引入css
    import 'tinymce/plugins/insertdatetime'  //插入日期时间
    import 'tinymce/plugins/link'  //超链接
    import 'tinymce/plugins/lists' //列表插件
    import 'tinymce/plugins/media' //插入编辑媒体
    import 'tinymce/plugins/nonbreaking' //插入不间断空格
    import 'tinymce/plugins/pagebreak' //插入分页符
    import 'tinymce/plugins/paste' //粘贴插件
    import 'tinymce/plugins/preview'//预览
    import 'tinymce/plugins/print'//打印
    import 'tinymce/plugins/quickbars'  //快速工具栏
    import 'tinymce/plugins/save'  //保存
    import 'tinymce/plugins/searchreplace'  //查找替换
    // import 'tinymce/plugins/spellchecker'  //拼写检查，暂未加入汉化，不建议使用
    import 'tinymce/plugins/tabfocus'  //切入切出，按tab键切出编辑器，切入页面其他输入框中
    import 'tinymce/plugins/table'  //表格
    import 'tinymce/plugins/template'  //内容模板
    import 'tinymce/plugins/textcolor'  //文字颜色
    import 'tinymce/plugins/textpattern'  //快速排版
    import 'tinymce/plugins/toc'  //目录生成器
    import 'tinymce/plugins/visualblocks'  //显示元素范围
    import 'tinymce/plugins/visualchars'  //显示不可见字符
    import 'tinymce/plugins/wordcount'  //字数统计

  const fonts = [
    "宋体=宋体",
    "微软雅黑=微软雅黑",
    "新宋体=新宋体",
    "黑体=黑体",
    "楷体=楷体",
    "隶书=隶书",
    "Courier New=courier new,courier",
    "AkrutiKndPadmini=Akpdmi-n",
    "Andale Mono=andale mono,times",
    "Arial=arial,helvetica,sans-serif",
    "Arial Black=arial black,avant garde",
    "Book Antiqua=book antiqua,palatino",
    "Comic Sans MS=comic sans ms,sans-serif",
    "Courier New=courier new,courier",
    "Georgia=georgia,palatino",
    "Helvetica=helvetica",
    "Impact=impact,chicago",
    "Symbol=symbol",
    "Tahoma=tahoma,arial,helvetica,sans-serif",
    "Terminal=terminal,monaco",
    "Times New Roman=times new roman,times",
    "Trebuchet MS=trebuchet ms,geneva",
    "Verdana=verdana,geneva",
    "Webdings=webdings",
    "Wingdings=wingdings,zapf dingbats"
  ];
  export default {
    components: {
      Editor
    },
    props: {
      //内容
      value: {
        type: String,
        default: ''
      },
      //是否禁用
      disabled: {
        type: Boolean,
        default: false
      },
      // 用于区分单个tinymce
     tinymceId: {
      type: String,
      default: "tinymce"
    },
      //插件
      plugins: {
        type: [String, Array],
        default: 'advlist autolink link image lists charmap  media wordcount'
      },
      //工具栏
      toolbar: {
        type: [String, Array],
        default: 'undo redo |  formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists image media table'
      }
    },
    data() {
      return {
        //初始化配置

        myValue :this.value,
        init: {
            language_url: '/static/tinymce/langs/zh_CN.js',  //引入语言包文件
            language: 'zh_CN',  //语言类型

            skin_url: '/static/tinymce/skins/ui/oxide',  //皮肤：浅色
            menubar: false, // 隐藏菜单栏
            autoresize_bottom_margin: 50,
            max_height: 450,
            min_height: 350,
            //   height: 320,
            toolbar_mode: "none",
            plugins:
                "print preview searchreplace autolink directionality visualblocks visualchars fullscreen image link media template code  table charmap hr pagebreak nonbreaking  insertdatetime lists wordcount textpattern", // 插件需要import进来
            toolbar:
                "cut copy paste pastetext selectall | formatselect fontselect fontsizeselect | table image media charmap hr | code  searchreplace visualblocks |  fullscreen  ','forecolor backcolor bold italic underline strikethrough link  |alignleft aligncenter alignright alignjustify outdent indent lineheight |  bullist numlist | blockquote subscript superscript  pagebreak insertdatetime print preview",
            content_style: "p {margin: 5px 0; font-size: 14px}",
            fontsize_formats: "12px 14px 16px 18px 24px 36px 48px 56px 72px",
            font_formats:
                "微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;",
            branding: false,
            elementpath: false,
            height: 450,
            resize: true, // 禁止改变大小
            statusbar: false, // 隐藏底部状态栏
            //图片上传
            images_upload_handler: function (blobInfo, success, failure) {
                //文件上传的formData传递，忘记为什么要用这个了
                const isAccord = blobInfo.blob().type === 'image/jpeg' || blobInfo.blob().type === 'image/png' || blobInfo.blob().type === 'image/GIF' || blobInfo.blob().type === 'image/jpg' || blobInfo.blob().type === 'image/BMP';
                if (blobInfo.blob().size/1024/1024>2) {
                    failure("上传失败，图片大小请控制在 2M 以内")
                } else {
                    let params = new FormData()
                    params.append('file', blobInfo.blob())
                    ajax.post("http://172.16.0.78:8801/api/upload/uploadFile", params).then(res => {
                        success(res.data.data)
                    }).catch(() => {
                        failure("上传出错，服务器开小差了呢")
                    })
                }
            }
        }
      }
    },
    watch: {
      //监听内容变化
      value(newValue) {
        this.myValue = (newValue == null ? '' : newValue)
      },
      myValue (newValue) {
        if(this.triggerChange){
          this.$emit('change', newValue)
        }else{
          this.$emit('input', newValue)
        }
      }
    },
    mounted () {
      tinymce.init({})
      // console.log(this.toolbar,'======')
    },
    methods: {
      onClick(e) {
        this.$emit('onClick', e, tinymce)
      },
      //可以添加一些自己的自定义事件，如清空内容
      clear() {
        this.myValue = ''
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/mycomponents/tinymce/tinymce.vue